import React from "react";

/**
 * PricingRow — horizontal line in a marketing pricing card.
 *
 * Shared by `Landing.js` and `PetsLanding.js` so both pages can't drift
 * apart when pricing copy shifts. If a page needs a one-off tweak (e.g.
 * a different eyebrow or CTA per row), extend the props here rather
 * than forking the component.
 */
export function PricingRow({ name, priceSmall, priceLarge, capacity, whyPay, highlight, badge }) {
  return (
    <div
      className={`relative flex items-baseline justify-between gap-3 py-4 border-b border-[color:var(--line-soft)] last:border-b-0 ${
        highlight ? "bg-[color:var(--bg-soft,#F5EFE2)] -mx-4 px-4 rounded-xl" : ""
      }`}
    >
      {badge && (
        <span
          className="absolute -top-2 left-3 inline-flex items-center gap-1 rounded-full bg-[color:var(--accent,#1E2A44)] text-[color:var(--bg)] text-[10px] uppercase tracking-[0.06em] px-2 py-0.5"
          data-testid="pricing-row-badge"
        >
          {badge}
        </span>
      )}
      <div>
        <div className="text-lg font-semibold tracking-tight">{name}</div>
        <div className="label-tiny text-[color:var(--ink-3)]">{capacity}</div>
        {whyPay && (
          <div className="label-tiny text-[color:var(--ink-2)] mt-1 italic">
            {whyPay}
          </div>
        )}
      </div>
      <div className="text-right">
        <div className="font-display text-2xl tracking-tighter tabular">{priceLarge}</div>
        {priceSmall && (
          <div className="label-tiny text-[color:var(--ink-3)]">{priceSmall}</div>
        )}
      </div>
    </div>
  );
}
